import { useGetSinglePage } from 'react-easyrocket';
import { CmsContent } from 'src/components/CmsContent';
import { ModalWrapper } from 'src/components/ModalWrapper';
import { SkeletonForIosSetupModal } from 'src/components/SkeletonForIosSetupModal';

const IosSetupModal = () => {
  const { data, isLoading } = useGetSinglePage('ios_app');

  if (data && !isLoading) {
    return (
      <ModalWrapper>
        <div className="p-[20px] h-full 768:min-w-[550px] max-w-[550px] min-w-full text-ism_text">
          <p className="w-full font-bold text-[20px] mb-[40px] text-ism_title">
            {data.title || ''}
          </p>
          <CmsContent
            content={data.content}
            className="text-[16px]  font-medium text-ism_text cms-dropdown"
          />
        </div>
      </ModalWrapper>
    );
  }

  return (
    <ModalWrapper>
      <SkeletonForIosSetupModal />
    </ModalWrapper>
  );
};

// eslint-disable-next-line no-restricted-exports
export default IosSetupModal;
